import 'core-js/stable/global-this'
import 'core-js/stable/object/entries'
import * as MFRuntime from '@module-federation/enhanced/runtime'
import * as MFSDK from '@module-federation/sdk'
//
import {reactAdapter} from 'src/adapter'
import {shareGlobalName} from 'src/helper/config'
import {EMPRuntime} from 'src/runtime'
const runtime = new EMPRuntime({MFRuntime, MFSDK})
export {MFRuntime, MFSDK, reactAdapter, runtime}

window[shareGlobalName] = {
  MFRuntime,
  MFSDK,
  reactAdapter,
  runtime,
}
